import React from "react";
import Nav from "../../Components/Navbar/Nav";
import Footer from "../../Components/Footer/Footer";
import Hero from "../../Components/Hero/Hero";
import WorldNews from "../../Components/WorldNews/WorldNews";
import Crypto from "../../Components/Crypto/Crypto";
import Trend from "../../Components/Trend/Trend";
import Construction from "../../Pages/construction/Construction";
import Dynamic from "../../Components/Dynamic/Dynamic";
// import Pagination from '../../Components/Pagination/Pagination'

const Home = () => {
  return (
    // <Construction />
    <div>
      <Nav />
      <Hero />
      <Dynamic />
      <WorldNews />
      <Crypto />
      <Trend />
      {/* <Pagination/> */}
      <Footer />
    </div>
  );
};

export default Home;
